import React from "react";
import { AppBar, Grid, Stack, Button, Typography } from "@mui/material";
import { Heading } from "./FooterStyled";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import {
  FooterSiteMap,
  FooterSite1,
  FooterSite2,
  FooterSite2mobile,
  FooterSite3,
  FooterSite3mobile,
  FooterGetInTouch,
  FooterGetInTouch1,
  FooterGetInTouch2,
  FooterGetInTouch2mobile,
  FooterGetInTouch3,
  FooterGetInTouch3mobile,
  FooterGetInTouch4,
  FooterSocials,
  FooterSocials1,
  FooterSocials2,
  FooterSocials3,
  FooterSocials4,
  FooterDashboard,
  FooterDashboardButton,
} from "../../common/strings";

const Footer = () => {
  return (
    <AppBar sx={{ backgroundColor: "#005EDB" }} position="static">
      <Grid container sx={{ pt: "2%", pb: "2%" }}>
        <Grid item xs={0.5} sm={0.5} md={1} lg={1} xl={1}></Grid>
        <Grid
          item
          md={2}
          lg={2}
          xl={2}
          sx={{ display: { xs: "none", md: "inline" } }}
        >
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={4}
          >
            <Heading sx={{ fontSize: { xs: "15px", md: "20px" } }}>
              {FooterSiteMap}
            </Heading>

            <Button href="/" sx={{ color: "white" }}>
              {FooterSite1}
            </Button>
            <Button href="/aboutus" sx={{ color: "white" }}>
              {FooterSite2}
            </Button>
            <Button href="/events" sx={{ color: "white" }}>
              {FooterSite3}
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} sx={{ m: "2%", display: { md: "none" } }}>
          <Heading sx={{ textAlign: "center", fontSize: "15px" }}>
            {FooterSiteMap}
          </Heading>

          <Stack
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <Button href="/" sx={{ color: "white", fontSize: "10px" }}>
              {FooterSite1}
            </Button>
            <Button href="/aboutus" sx={{ color: "white", fontSize: "10px" }}>
              {FooterSite2mobile}
            </Button>
            <Button href="/events" sx={{ color: "white", fontSize: "10px" }}>
              {FooterSite3mobile}
            </Button>
          </Stack>
        </Grid>
        <Grid
          item
          md={2}
          lg={2}
          xl={2}
          sx={{ display: { xs: "none", md: "inline" } }}
        >
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <Heading sx={{ fontSize: "20px" }}>{FooterGetInTouch}</Heading>

            <Button
              target="_blank"
              href="https://dsc-srmrmp.github.io/"
              sx={{ color: "white" }}
            >
              {FooterGetInTouch1}
            </Button>
            <Button href="/contactus" sx={{ color: "white" }}>
              {FooterGetInTouch2}
            </Button>
            <Button href="/ourteam" sx={{ color: "white" }}>
              {FooterGetInTouch3}
            </Button>
            <Button href="/sponsor" sx={{ color: "white" }}>
              {FooterGetInTouch4}
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} sx={{ m: "0px", display: { md: "none" },p:"0px" }}>
          <Heading sx={{ fontSize: "15px", textAlign: "center",p:"0px" }}>
            {FooterGetInTouch}
          </Heading>

          <Stack
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={0.5}
          >
            <Button
              target="_blank"
              href="https://dsc-srmrmp.github.io/"
              sx={{ color: "white", fontSize: "10px" }}
            >
              {FooterGetInTouch1}
            </Button>
            <Button href="/contactus" sx={{ color: "white", fontSize: "10px" }}>
              {FooterGetInTouch2mobile}
            </Button>
            <Button href="/ourteam" sx={{ color: "white", fontSize: "10px" }}>
              {FooterGetInTouch3mobile}
            </Button>
            <Button href="/sponsor" sx={{ color: "white", fontSize: "10px" }}>
              {FooterGetInTouch4}
            </Button>
          </Stack>
        </Grid>
        <Grid
          item
          md={2}
          lg={2}
          xl={2}
          sx={{ display: { xs: "none", md: "inline" } }}
        >
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <Heading sx={{ fontSize: { xs: "15px", md: "20px" } }}>
              {FooterSocials}
            </Heading>

            <Button
              color="inherit"
              href="https://twitter.com/dscsrmramapuram"
              target="_blank"
              sx={{ borderRadius: "100px", textTransform: "none" }}
              startIcon={<TwitterIcon />}
            >
              {FooterSocials1}
            </Button>
            <Button
              color="inherit"
              href="https://www.instagram.com/dscsrm.rmp/"
              target="_blank"
              sx={{ borderRadius: "100px", textTransform: "none" }}
              startIcon={<InstagramIcon />}
            >
              {FooterSocials2}
            </Button>
            <Button
              color="inherit"
              href="https://www.linkedin.com/company/dsc-srm-ramapuram/"
              target="_blank"
              sx={{ borderRadius: "100px", textTransform: "none" }}
              startIcon={<LinkedInIcon />}
            >
              {FooterSocials3}
            </Button>
            <Button
              color="inherit"
              href="https://www.youtube.com/channel/UCEym9CYeeSWiMtQwN9YQXOQ"
              target="_blank"
              sx={{ borderRadius: "100px", textTransform: "none" }}
              startIcon={<YouTubeIcon />}
            >
              {FooterSocials4}
            </Button>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={12} sx={{ m: "0px", display: { md: "none" },p:"1%" }}>
          <Heading sx={{ fontSize: "15px", textAlign: "center",p:"opx" }}>
            {FooterSocials}
          </Heading>

          <Stack
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={0}
          >
            <Button
              color="inherit"
              href="https://twitter.com/dscsrmramapuram"
              target="_blank"
              sx={{
                borderRadius: "100px",
                textTransform: "none",
                fontSize: "8px",
              }}
              startIcon={<TwitterIcon />}
            >
              {FooterSocials1}
            </Button>
            <Button
              color="inherit"
              href="https://www.instagram.com/dscsrm.rmp/"
              target="_blank"
              sx={{
                borderRadius: "100px",
                textTransform: "none",
                fontSize: "8px",
              }}
              startIcon={<InstagramIcon />}
            >
              {FooterSocials2}
            </Button>
            <Button
              color="inherit"
              href="https://www.linkedin.com/company/dsc-srm-ramapuram/"
              target="_blank"
              sx={{
                borderRadius: "100px",
                textTransform: "none",
                fontSize: "8px",
              }}
              startIcon={<LinkedInIcon />}
            >
              {FooterSocials3}
            </Button>
            <Button
              color="inherit"
              href="https://www.youtube.com/channel/UCEym9CYeeSWiMtQwN9YQXOQ"
              target="_blank"
              sx={{
                borderRadius: "100px",
                textTransform: "none",
                fontSize: "8px",
              }}
              startIcon={<YouTubeIcon />}
            >
              {FooterSocials4}
            </Button>
          </Stack>
        </Grid>

        <Grid
          item
          md={4}
          lg={4}
          xl={4}
          sx={{
            textAlign: "center",
            mt: "auto",
            mb: "auto",
            display: { xs: "none", md: "inline" },
          }}
        >
          <Typography>{FooterDashboard}</Typography>
          <br />
          <Button
            variant="contained"
            href="https://gdsc.community.dev/accounts/login/?next=/srm-institute-of-science-and-technology-ramapuram-chennai/"
            target="_blank"
            sx={{
              borderRadius: "100px",
              textTransform: "none",
              backgroundColor: "#ffffff",
              color: "#005EDB",
              "&:hover": { backgroundColor: "#ffffff", color: "#005EDB" },
              fontWeight: "700",
            }}
          >
            {FooterDashboardButton}
          </Button>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          sx={{
            textAlign: "center",
            mt: "auto",
            mb: "auto",
            display: { md: "none" },
          }}
        >
          <br />
          <Typography sx={{ textSize: "10px" }}>{FooterDashboard}</Typography>
          <br />
          <Button
            variant="contained"
            href="https://gdsc.community.dev/accounts/login/?next=/srm-institute-of-science-and-technology-ramapuram-chennai/"
            target="_blank"
            sx={{
              borderRadius: "100px",
              textSize: "10px",
              textTransform: "none",
              backgroundColor: "#ffffff",
              color: "#005EDB",
              "&:hover": { backgroundColor: "#ffffff", color: "#005EDB" },
              fontWeight: "700",
            }}
          >
            {FooterDashboardButton}
          </Button>
        </Grid>
        <Grid
          item
          xs={0.5}
          sm={0.5}
          md={1}
          lg={1}
          xl={1}
          sx={{ display: { md: "none" } }}
        ></Grid>
      </Grid>
    </AppBar>
  );
};

export default Footer;